import OperatorDetails from './OperatorDetails'

export default OperatorDetails
